function richTextMarkup(selector: string = 'fo', text: string = '', unique: string = '') {
  return {
    tagName: 'foreignObject',
    selector: selector,
    children: [
        {
          tagName: 'div',
          namespaceURI: 'http://www.w3.org/1999/xhtml',
          selector: `textContainer${unique}`,
          className: 'ql-snow',
          children: [{
              tagName: 'div',
              className: 'ql-editor',
              selector: `richText${unique}`,
              textContent: text,
              style: {
                margin: '0',
                width: '100%'
              }
          }]
        }
    ]
  }
}

const defaultStyle = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  fontSize: '12px',
}

export const textMarkup = (text: string = '', wrap: any = { tagName: 'rect', selector: 'body' }) => {
  let markup = []
  if (Array.isArray(wrap)){
    markup.push(...wrap)
  } else {
    markup.push(wrap)
  }
  markup.push(
    richTextMarkup('fo', text)
  )
  return markup
};

export const headerRectangleMarkup = () => {
  let markup = [
    {
      tagName: 'rect',
      selector: 'body'
    },
    {
      tagName: 'rect',
      selector: 'header',
    }
  ]
  markup.push(
    richTextMarkup('headerText', '', 'Header')
  )
  markup.push(
    richTextMarkup('bodyText', '', 'Body')
  )
  return markup
}

export const textAttrs = (style: any = {}) => ({
  fo: {
    x: 0,
    y: 0,
    width: 'calc(w)',
    height: 'calc(h)'
  },
  richText: {
    content: '<div style="text-align: center">Text here</div>'
  },
  textContainer: {
    style: {
      ...defaultStyle,
      ...style
    }
  }
})

export const cardTextAttrs = () => ({
  fo: {
    x: 'calc(0.35*w + 5)',
    y: 0,
    width: 'calc(0.65*w)',
    height: 'calc(h)'
  },
  richText: {
    content: '<div style="text-align: left">Text here</div>'
  },
  textContainer: {
    style: {
      ...defaultStyle,
      padding: '5px',
    }
  }
})

export const headerRectangleAttrs = () => ({
  headerText: {
    x: 0,
    y: 0,
    width: 'calc(w)',
    height: 25
  },
  bodyText: {
    x: 0,
    y: 25,
    width: 'calc(w - 5)',
    height: 'calc(h - 25)'
  },
  textContainerHeader: {
    class: 'joint-shape-header',
    style: {
      ...defaultStyle,
      padding: '5px',
    },
  },
  textContainerBody: {
    style: {
      ...defaultStyle,
      padding: '5px',
    }
  },
  richTextHeader: {
    content: '<div style="text-align: center;">Header</div>'
  },
  richTextBody: {
    content: '<div style="text-align: center;">Text here</div>'
  }
})


export function getSupplierColorKey(data: any) {
  switch (data) {
    case 'Severe Concern':
      return 'dark-red';
    case 'Significant Concern':
      return 'bright-red';
    case 'Moderate Concern':
      return 'yellow';
    case 'No Concerns':
      return 'bright-green';
    case 'Not Assessed':
      return 'bright-secondary';
    case 'Not Applicable':
      return 'light-secondary';
    // case 'Empty':
    //   return 'bg-white';
    default:
      return 'bright-secondary';
  }
}



export const supplierColor: any = {
  "dark-red": {
    "fill": "#8d1101",
    "text": "#ffffff",
    "order": 6
  },
  "bright-red": {
    "fill": "#d90606",
    "text": "#ffffff",
    "order": 5
  },
  "yellow": {
    "fill": "#ffcf11",
    "order": 4
  },
  "bright-green": {
    "fill": "#4cc013",
    "order": 3
  },
  "bright-secondary": {
    "fill": "#c3c3c3",
    "order": 2
  },
  "light-secondary": {
    "fill": "#ededed",
    "order": 1
  }
}

export function getOTColorKey(data: any) {
  // Handle both capitalized and lowercase versions
  const normalized = typeof data === 'string' ? data.trim() : '';
  
  switch (normalized) {
    case 'Severe Concern':
    case 'severe concern':
      return 'maroon';
    case 'Significant Concern':
    case 'significant concern':
      return 'red';
    case 'Moderate Concern':
    case 'moderate concern':
      return 'amber';
    case 'No Concern':
    case 'No Concerns':
    case 'no concern':
    case 'no concerns':
      return 'green';
    case 'Not Assessed':
    case 'not assessed':
      return 'grey';
    case 'Not Applicable':
    case 'not applicable':
      return 'grey';
    default:
      return 'grey';
  }
}

export const otColor: any = {
  "maroon": {
    "fill": "#800000",
    "text": "#ffffff",
    "order": 4
  },
  "red": {
    "fill": "#d90606",
    "text": "#ffffff",
    "order": 3
  },
  "amber": {
    "fill": "#FFBF00",
    "text": "#000000",
    "order": 2
  },
  "green": {
    "fill": "#4cc013",
    "text": "#ffffff",
    "order": 1
  },
  "grey": {
    "fill": "#c3c3c3",
    "text": "#000000",
    "order": 0
  }
}
